import { getApiBaseUrl } from '@/config/apiBase'

export { getApiBaseUrl } from '@/config/apiBase'

/** Origem do backend (scheme + host + port) para Socket.IO e `/uploads`. */
export function getBackendOrigin(): string {
  const apiUrl = getApiBaseUrl()
  if (/^https?:\/\//i.test(apiUrl)) {
    return apiUrl.replace(/\/api(\/v\d+)?\/?$/i, '')
  }
  if (typeof window !== 'undefined') {
    return window.location.origin
  }
  return ''
}
